<template>
    <vuejs-datepicker :typeable="false" ref="mainChild" @input="$emit('input', $event)"
                      v-bind="{value, disabled, disabledDates, highlighted}" :language="dynLanguage"/>
</template>

<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import {default as VuejsDatepicker} from 'vuejs-datepicker';
    import i18n from '@/languages';
    import {getLanguage} from '@/languages';

    @Component({
        components: {
            VuejsDatepicker
        }
    })
    export default class Datepicker extends Vue {

        dynLanguage = {
            get language() {
                return i18n.locale;
            },
            get months() {
                return i18n.t('datepicker.months');
            },
            get monthsAbbr() {
                return i18n.t('datepicker.months_short');
            },
            get days() {
                return i18n.t('datepicker.days');
            },
            get rtl() {
                return false;
            },
            get ymd() {
                return false;
            },
            get yearSuffix() {
                return i18n.t('datepicker.year_suffix');
            }
        };

        @Prop({type: Date})
        value;
        @Prop({type: Boolean, default: false})
        disabled;
        @Prop({type: Object})
        disabledDates;
        @Prop({type: Object})
        highlighted;

        mounted() {
            // BUG: Configure input to be not editable, fixed in vuejs-datepicker after 1.5.3 and up (not available at time of writing)
            // Fixed by: https://github.com/charliekassel/vuejs-datepicker/pull/547
            this.$refs.mainChild.$el.querySelector('input').readOnly = true;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Datepicker.vue